import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Csdowhile(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>

      <Helmet>
 
 <title>Learn Free JavaScript Do While Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript do While tutorial for beginners In do-while, the Javascript loop will consistently execute at least once." />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript do While,Javascript do While for loop,do While foreach Javascript,Javascript foreach do While,do while in javascript,javascript do while loop,javascript do while async,javascript do while break,javascript do while vs while" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-do-while" />
 </Helmet>

 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">Do-while Loop Statement in Javascript</h1>
    <div className="first">
        <a href="/javascript-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">In do-while, the Javascript loop will consistently execute at least once.
</p>


<h2 className="headings">Syntax do-while Javascript loop:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-10">do</span>
        {"\n"}
        <span className="qwerty-3">&#123; </span>

  {"\n"}
  <span className="qwerty-2">&nbsp;statement</span>
  {"\n"}
  <span className="qwerty-3">&#125; </span>
  {"\n"}
  <span className="qwerty-10">while</span>
  <span className="qwerty-1">(</span>
    <span className="qwerty-4">condition</span> 
  <span className="qwerty-1">);</span>
  {"\n"}
  
{"\n"}
     </code>
      </pre>        
    </div>


     
<h2 className="headings">Q-Write a program for loop in Do while loop and print names Example in Javascript?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
{"\n"}
<span className="qwerty-3">&#60;</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
          {"\n"}

          <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">1; </span>
          {"\n"}




          {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;do</span>
          {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"}
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">write</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-1">"</span>
      <span className="qwerty-3">Hello code Exampler </span>
    
        <span className="qwerty-1">"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
          <span className="qwerty">=</span>
          <span className="qwerty-4">a</span>
          <span className="qwerty">+</span>
          <span className="qwerty-1">1;</span>
          {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
    
     
    
    
     
     
    
    
    
    {"\n"}
      <span className="qwerty-10">&nbsp;&nbsp;while</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span>
      <span className="qwerty">&#60;=</span>  
      <span className="qwerty-1">10</span>   
      <span className="qwerty-1">)</span>
      {"\n"}
        







<span className="qwerty-3">&#60;/</span>
<span className="qwerty-8">script</span>
          <span className="qwerty-3">&#62; </span>
            {"\n"}
    
    
    
    
            {"\n"}
       
        </code>
      </pre>        
    </div>
    
      
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          <span className="qwerty-3">&nbsp;Hello code Exampler </span>                    
          {"\n"}
          
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">
        Q-Write a program Addition or increment of 2 numbers every Times in do-while loop Example in Javascript?
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">1; </span>
            {"\n"}

            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;do</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-3">Hello code Exampler </span>
            <span className="qwerty-1">"</span>
            <span className="qwerty">+</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">+</span>
            <span className="qwerty-1">2;</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;while</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">&#60;=</span>
            <span className="qwerty-1">5</span>
            <span className="qwerty-1">)</span>
            {"\n"}

            <span className="qwerty-3">&#60;/</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;Hello code Exampler </span>
              <span className="qwerty-5">1</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;Hello code Exampler </span>
              <span className="qwerty-5">3</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;Hello code Exampler </span>
              <span className="qwerty-5">5</span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>


<h2 className="mt-4 mh2">Increment in Do while Javascript loop Example</h2>



<h2 className="headings">
        Q-Write a program Addition or increment of 1+ every Times in do-while loop Example in Javascript?
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">1; </span>
            {"\n"}

            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;do</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-3">Increment</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty">+</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
            <span className="qwerty">++</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;while</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">&#60;=</span>
            <span className="qwerty-1">10</span>
            <span className="qwerty-1">)</span>
            {"\n"}

            <span className="qwerty-3">&#60;/</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-5">Increment No </span>
              <span className="qwerty-3">1 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">2 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">3 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">4 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">5 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">6 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">7 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">8 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">9 </span>
              {"\n"}
              <span className="qwerty-5">Increment No </span>{" "}
              <span className="qwerty-3">10 </span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>


<h2 className="mt-4 mh2">Decrement in Do while Javascript Example</h2>



<h2 className="headings">
        Q-Write a program Subtract or decrement of -1 numbers every Times in do-while loop Example in Javascript?
      </h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            <span className="qwerty-4">&nbsp;&nbsp;var </span>
            <span className="qwerty-3">a</span>
            <span className="qwerty">=</span>
            <span className="qwerty-1">10; </span>
            {"\n"}

            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;do</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
            {"\n"}
            <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;document</span>
            <span className="qwerty">.</span>
            <span className="qwerty-2">write</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty-3">Decrenment</span>
            <span className="qwerty-1">"</span>
            <span className="qwerty">+</span>
            <span className="qwerty-4">a</span>

            <span className="qwerty-1">);</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;a</span>
            <span className="qwerty">--</span>
            <span className="qwerty-1">;</span>
            {"\n"}
            <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

            {"\n"}
            <span className="qwerty-10">&nbsp;&nbsp;while</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">&#62;=</span>
            <span className="qwerty-1">1</span>
            <span className="qwerty-1">)</span>
            {"\n"}

            <span className="qwerty-3">&#60;/</span>
            <span className="qwerty-8">script</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-10">Decrement No </span>
              <span className="qwerty-3">10 </span>
              {"\n"}
              <span className="qwerty-5">Decrement No </span>{" "}
              <span className="qwerty-3">9 </span>
              {"\n"}
              <span className="qwerty-10">Decrement No </span>{" "}
              <span className="qwerty-3">8 </span>
              {"\n"}
              <span className="qwerty-5">Decrement No </span>{" "}
              <span className="qwerty-3">7 </span>
              {"\n"}
              <span className="qwerty-10">Decrement No </span>{" "}
              <span className="qwerty-3">6 </span>
              {"\n"}
              <span className="qwerty-5">Decrement No </span>{" "}
              <span className="qwerty-3">5 </span>
              {"\n"}
              <span className="qwerty-10">Decrement No </span>{" "}
              <span className="qwerty-3">4 </span>
              {"\n"}
              <span className="qwerty-5">Decrement No </span>{" "}
              <span className="qwerty-3">3 </span>
              {"\n"}
              <span className="qwerty-10">Decrement No </span>{" "}
              <span className="qwerty-3">2 </span>
              {"\n"}
              <span className="qwerty-5">Decrement No </span>{" "}
              <span className="qwerty-3">1 </span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>

  <h1 className="mt-5">  </h1>
    
  <div className="back">
        <a href="/javascript-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-for-loop">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Csdowhile;